// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Loader Animation */

/* styles.css */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(5px);
  }
}

.animate-fade-in {
  animation: fadeIn 0.4s ease-out forwards;
}

.animate-fade-out {
  animation: fadeOut 0.4s ease-in forwards;
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-scale-in {
  animation: scaleIn 0.4s ease-in-out forwards;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes scaleIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Google Animation */
.recording-status {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5em;
  height: 1.5em;
}

.ball {
  width: 22px;
  height: 22px;
  border-radius: 11px;
  margin: 11px;
}

.idle {
  animation: bounce 2s ease infinite;
}

.nope {
  animation: shake 0.3s linear 3;
}

.talk-long {
  animation: talk-long-anim 2s ease infinite;
}

.talk-short {
  animation: talk-short-anim 2s ease infinite;
}

.blue-ball {
  background-color: #0d6efd;
}

.red-ball {
  background-color: #ea4436;
  animation-delay: 0.25s;
}

.yellow-ball {
  background-color: #fbbd06;
  animation-delay: 0.5s;
}

.green-ball {
  background-color: #34a952;
  animation-delay: 0.75s;
}

.red-nope {
  animation-delay: 0.07s;
}

.yellow-nope {
  animation-delay: 0.14s;
}

.green-nope {
  animation-delay: 0.21s;
}

.think {
  animation: think 1s linear infinite;
  animation-delay: 0.4s;
}

.blue-think {
  transform: translateX(44px) translateY(-22px);
  animation: blue-think 0.5s linear;
}

.red-think {
  transform: translateX(44px) translateY(-22px);
  animation: red-think 0.5s linear;
}

.yellow-think {
  transform: translateY(22px);
  animation: yellow-think 0.5s linear;
}

.green-think {
  transform: translateX(-88px) translateY(22px);

  animation: green-think 0.5s linear;
}

@keyframes bounce {
  50% {
    transform: translateY(25px);
  }
}

@keyframes talk-long-anim {
  10% {
    height: 132px;
  }
  20%,
  40% {
    height: 78px;
  }
  30%,
  50% {
    height: 98px;
  }
  60%,
  80% {
    height: 56px;
  }
  70% {
    height: 76px;
  }
  100% {
    height: 22px;
  }
}

@keyframes talk-short-anim {
  10%,
  30%,
  50% {
    height: 98px;
  }
  20%,
  40% {
    height: 78px;
  }
  60%,
  80% {
    height: 56px;
  }
  70% {
    height: 76px;
  }
  100% {
    height: 22px;
  }
}

@keyframes shake {
  25% {
    transform: translateX(-5.5px);
  }
  75% {
    transform: translateX(11px);
  }
}

@keyframes blue-think {
  0% {
    transform: translateX(-44px) translateY(22px);
  }
}

@keyframes red-think {
  0% {
    transform: translateX(-44px) translateY(22px);
  }
}

@keyframes yellow-think {
  0% {
    transform: translateY(-22px);
  }
}

@keyframes green-think {
  0% {
    transform: translateX(88px) translateY(-22px);
  }
}

@keyframes think {
  100% {
    transform: rotate(360deg);
  }
}

/* Pencel Animation */

.pencil {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5em;
  height: 1.5em;
}

.pencil__body1,
.pencil__body2,
.pencil__body3,
.pencil__eraser,
.pencil__eraser-skew,
.pencil__point,
.pencil__rotate,
.pencil__stroke {
  animation-duration: 3s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.pencil__body1,
.pencil__body2,
.pencil__body3 {
  transform: rotate(-90deg);
}

.pencil__body1 {
  animation-name: pencilBody1;
}

.pencil__body2 {
  animation-name: pencilBody2;
}

.pencil__body3 {
  animation-name: pencilBody3;
}

.pencil__eraser {
  animation-name: pencilEraser;
  transform: rotate(-90deg) translate(49px, 0);
}

.pencil__eraser-skew {
  animation-name: pencilEraserSkew;
  animation-timing-function: ease-in-out;
}

.pencil__point {
  animation-name: pencilPoint;
  transform: rotate(-90deg) translate(49px, -30px);
}

.pencil__rotate {
  animation-name: pencilRotate;
}

.pencil__stroke {
  animation-name: pencilStroke;
  transform: translate(100px, 100px) rotate(-113deg);
}

/* Animations */
@keyframes pencilBody1 {
  from,
  to {
    stroke-dashoffset: 351.86;
    transform: rotate(-90deg);
  }

  50% {
    stroke-dashoffset: 150.8;
    /* 3/8 of diameter */
    transform: rotate(-225deg);
  }
}

@keyframes pencilBody2 {
  from,
  to {
    stroke-dashoffset: 406.84;
    transform: rotate(-90deg);
  }

  50% {
    stroke-dashoffset: 174.36;
    transform: rotate(-225deg);
  }
}

@keyframes pencilBody3 {
  from,
  to {
    stroke-dashoffset: 296.88;
    transform: rotate(-90deg);
  }

  50% {
    stroke-dashoffset: 127.23;
    transform: rotate(-225deg);
  }
}

@keyframes pencilEraser {
  from,
  to {
    transform: rotate(-45deg) translate(49px, 0);
  }

  50% {
    transform: rotate(0deg) translate(49px, 0);
  }
}

@keyframes pencilEraserSkew {
  from,
  32.5%,
  67.5%,
  to {
    transform: skewX(0);
  }

  35%,
  65% {
    transform: skewX(-4deg);
  }

  37.5%,
  62.5% {
    transform: skewX(8deg);
  }

  40%,
  45%,
  50%,
  55%,
  60% {
    transform: skewX(-15deg);
  }

  42.5%,
  47.5%,
  52.5%,
  57.5% {
    transform: skewX(15deg);
  }
}

@keyframes pencilPoint {
  from,
  to {
    transform: rotate(-90deg) translate(49px, -30px);
  }

  50% {
    transform: rotate(-225deg) translate(49px, -30px);
  }
}

@keyframes pencilRotate {
  from {
    transform: translate(100px, 100px) rotate(0);
  }

  to {
    transform: translate(100px, 100px) rotate(720deg);
  }
}

@keyframes pencilStroke {
  from {
    stroke-dashoffset: 439.82;
    transform: translate(100px, 100px) rotate(-113deg);
  }

  50% {
    stroke-dashoffset: 164.93;
    transform: translate(100px, 100px) rotate(-113deg);
  }

  75%,
  to {
    stroke-dashoffset: 439.82;
    transform: translate(100px, 100px) rotate(112deg);
  }
}

/* Learmo Loader */

.pl,
.pl__worm {
  animation-duration: 3s;
  animation-iteration-count: infinite;
}

.pl {
  animation-name: bump9;
  animation-timing-function: linear;
  width: 1.5em;
  height: 1.5em;
}

.pl__ring {
  stroke: hsla(var(--hue), 10%, 10%, 0.1);
  transition: stroke 0.3s;
}

.pl__worm {
  animation-name: worm9;
  animation-timing-function: cubic-bezier(0.42, 0.17, 0.75, 0.83);
}

/* Animations */
@keyframes bump9 {
  from,
  42%,
  46%,
  51%,
  55%,
  59%,
  63%,
  67%,
  71%,
  74%,
  78%,
  81%,
  85%,
  88%,
  92%,
  to {
    transform: translate(0, 0);
  }

  44% {
    transform: translate(1.33%, 6.75%);
  }

  53% {
    transform: translate(-16.67%, -0.54%);
  }

  61% {
    transform: translate(3.66%, -2.46%);
  }

  69% {
    transform: translate(-0.59%, 15.27%);
  }

  76% {
    transform: translate(-1.92%, -4.68%);
  }

  83% {
    transform: translate(9.38%, 0.96%);
  }

  90% {
    transform: translate(-4.55%, 1.98%);
  }
}

@keyframes worm9 {
  from {
    stroke-dashoffset: 10;
  }

  25% {
    stroke-dashoffset: 295;
  }

  to {
    stroke-dashoffset: 1165;
  }
}

/* Wrapper */
.ai-loader-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 1090;
  animation: float 3s ease-in-out infinite;
}

/* Bubble */
.ai-bubble {
  position: absolute;
  max-width: 240px;
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow:
    0 8px 30px rgba(0, 0, 0, 0.12),
    inset 0 0 0 1px rgba(255, 255, 255, 0.4);
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  text-align: center;
  pointer-events: none;
  transform-origin: center;
}

.ai-bubble.inside {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* Positioning */
.ai-bubble.bottom {
  top: 100%;
  margin-top: 5px;
}

.ai-bubble.top {
  bottom: 100%;
  margin-bottom: 14px;
}

/* Text */
.ai-bubble-text {
  display: inline-block;
  line-height: 1.4;
}

/* Connector (modern instead of arrow) */
.ai-bubble-connector {
  position: absolute;
  left: 50%;
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  transform: translateX(-50%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.ai-bubble.bottom .ai-bubble-connector {
  top: -4px;
}

.ai-bubble.top .ai-bubble-connector {
  bottom: -4px;
}

/* Animations */
.fade-in {
  animation: bubbleIn 0.35s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.fade-out {
  animation: bubbleOut 0.25s ease-in forwards;
}

@keyframes bubbleIn {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(4px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes bubbleOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.96);
  }
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/ai/ai-thinking-loader/ai-thinking-loader.component.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB,eAAe;AACf;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;;EAE7C,kCAAkC;AACpC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;;IAEE,YAAY;EACd;EACA;;IAEE,YAAY;EACd;EACA;;IAEE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;;;IAGE,YAAY;EACd;EACA;;IAEE,YAAY;EACd;EACA;;IAEE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;;;;EAQE,sBAAsB;EACtB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA,eAAe;AACf;EACE;;IAEE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,4CAA4C;EAC9C;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;;;;IAIE,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;;;;IAKE,wBAAwB;EAC1B;;EAEA;;;;IAIE,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,gDAAgD;EAClD;;EAEA;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,kDAAkD;EACpD;;EAEA;IACE,yBAAyB;IACzB,kDAAkD;EACpD;;EAEA;;IAEE,yBAAyB;IACzB,iDAAiD;EACnD;AACF;;AAEA,kBAAkB;;AAElB;;EAEE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA,eAAe;AACf;EACE;;;;;;;;;;;;;;;;IAgBE,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC;;4CAE0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA,gBAAgB;AAChB;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,iEAAiE;AACnE;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA,w0jBAAw0jB","sourcesContent":["/* AI Loader Animation */\n\n/* styles.css */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.4s ease-out forwards;\n}\n\n.animate-fade-out {\n  animation: fadeOut 0.4s ease-in forwards;\n}\n\n.animate-float {\n  animation: float 3s ease-in-out infinite;\n}\n\n.animate-scale-in {\n  animation: scaleIn 0.4s ease-in-out forwards;\n}\n\n@keyframes float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Google Animation */\n.recording-status {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1.5em;\n  height: 1.5em;\n}\n\n.ball {\n  width: 22px;\n  height: 22px;\n  border-radius: 11px;\n  margin: 11px;\n}\n\n.idle {\n  animation: bounce 2s ease infinite;\n}\n\n.nope {\n  animation: shake 0.3s linear 3;\n}\n\n.talk-long {\n  animation: talk-long-anim 2s ease infinite;\n}\n\n.talk-short {\n  animation: talk-short-anim 2s ease infinite;\n}\n\n.blue-ball {\n  background-color: #0d6efd;\n}\n\n.red-ball {\n  background-color: #ea4436;\n  animation-delay: 0.25s;\n}\n\n.yellow-ball {\n  background-color: #fbbd06;\n  animation-delay: 0.5s;\n}\n\n.green-ball {\n  background-color: #34a952;\n  animation-delay: 0.75s;\n}\n\n.red-nope {\n  animation-delay: 0.07s;\n}\n\n.yellow-nope {\n  animation-delay: 0.14s;\n}\n\n.green-nope {\n  animation-delay: 0.21s;\n}\n\n.think {\n  animation: think 1s linear infinite;\n  animation-delay: 0.4s;\n}\n\n.blue-think {\n  transform: translateX(44px) translateY(-22px);\n  animation: blue-think 0.5s linear;\n}\n\n.red-think {\n  transform: translateX(44px) translateY(-22px);\n  animation: red-think 0.5s linear;\n}\n\n.yellow-think {\n  transform: translateY(22px);\n  animation: yellow-think 0.5s linear;\n}\n\n.green-think {\n  transform: translateX(-88px) translateY(22px);\n\n  animation: green-think 0.5s linear;\n}\n\n@keyframes bounce {\n  50% {\n    transform: translateY(25px);\n  }\n}\n\n@keyframes talk-long-anim {\n  10% {\n    height: 132px;\n  }\n  20%,\n  40% {\n    height: 78px;\n  }\n  30%,\n  50% {\n    height: 98px;\n  }\n  60%,\n  80% {\n    height: 56px;\n  }\n  70% {\n    height: 76px;\n  }\n  100% {\n    height: 22px;\n  }\n}\n\n@keyframes talk-short-anim {\n  10%,\n  30%,\n  50% {\n    height: 98px;\n  }\n  20%,\n  40% {\n    height: 78px;\n  }\n  60%,\n  80% {\n    height: 56px;\n  }\n  70% {\n    height: 76px;\n  }\n  100% {\n    height: 22px;\n  }\n}\n\n@keyframes shake {\n  25% {\n    transform: translateX(-5.5px);\n  }\n  75% {\n    transform: translateX(11px);\n  }\n}\n\n@keyframes blue-think {\n  0% {\n    transform: translateX(-44px) translateY(22px);\n  }\n}\n\n@keyframes red-think {\n  0% {\n    transform: translateX(-44px) translateY(22px);\n  }\n}\n\n@keyframes yellow-think {\n  0% {\n    transform: translateY(-22px);\n  }\n}\n\n@keyframes green-think {\n  0% {\n    transform: translateX(88px) translateY(-22px);\n  }\n}\n\n@keyframes think {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Pencel Animation */\n\n.pencil {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1.5em;\n  height: 1.5em;\n}\n\n.pencil__body1,\n.pencil__body2,\n.pencil__body3,\n.pencil__eraser,\n.pencil__eraser-skew,\n.pencil__point,\n.pencil__rotate,\n.pencil__stroke {\n  animation-duration: 3s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n}\n\n.pencil__body1,\n.pencil__body2,\n.pencil__body3 {\n  transform: rotate(-90deg);\n}\n\n.pencil__body1 {\n  animation-name: pencilBody1;\n}\n\n.pencil__body2 {\n  animation-name: pencilBody2;\n}\n\n.pencil__body3 {\n  animation-name: pencilBody3;\n}\n\n.pencil__eraser {\n  animation-name: pencilEraser;\n  transform: rotate(-90deg) translate(49px, 0);\n}\n\n.pencil__eraser-skew {\n  animation-name: pencilEraserSkew;\n  animation-timing-function: ease-in-out;\n}\n\n.pencil__point {\n  animation-name: pencilPoint;\n  transform: rotate(-90deg) translate(49px, -30px);\n}\n\n.pencil__rotate {\n  animation-name: pencilRotate;\n}\n\n.pencil__stroke {\n  animation-name: pencilStroke;\n  transform: translate(100px, 100px) rotate(-113deg);\n}\n\n/* Animations */\n@keyframes pencilBody1 {\n  from,\n  to {\n    stroke-dashoffset: 351.86;\n    transform: rotate(-90deg);\n  }\n\n  50% {\n    stroke-dashoffset: 150.8;\n    /* 3/8 of diameter */\n    transform: rotate(-225deg);\n  }\n}\n\n@keyframes pencilBody2 {\n  from,\n  to {\n    stroke-dashoffset: 406.84;\n    transform: rotate(-90deg);\n  }\n\n  50% {\n    stroke-dashoffset: 174.36;\n    transform: rotate(-225deg);\n  }\n}\n\n@keyframes pencilBody3 {\n  from,\n  to {\n    stroke-dashoffset: 296.88;\n    transform: rotate(-90deg);\n  }\n\n  50% {\n    stroke-dashoffset: 127.23;\n    transform: rotate(-225deg);\n  }\n}\n\n@keyframes pencilEraser {\n  from,\n  to {\n    transform: rotate(-45deg) translate(49px, 0);\n  }\n\n  50% {\n    transform: rotate(0deg) translate(49px, 0);\n  }\n}\n\n@keyframes pencilEraserSkew {\n  from,\n  32.5%,\n  67.5%,\n  to {\n    transform: skewX(0);\n  }\n\n  35%,\n  65% {\n    transform: skewX(-4deg);\n  }\n\n  37.5%,\n  62.5% {\n    transform: skewX(8deg);\n  }\n\n  40%,\n  45%,\n  50%,\n  55%,\n  60% {\n    transform: skewX(-15deg);\n  }\n\n  42.5%,\n  47.5%,\n  52.5%,\n  57.5% {\n    transform: skewX(15deg);\n  }\n}\n\n@keyframes pencilPoint {\n  from,\n  to {\n    transform: rotate(-90deg) translate(49px, -30px);\n  }\n\n  50% {\n    transform: rotate(-225deg) translate(49px, -30px);\n  }\n}\n\n@keyframes pencilRotate {\n  from {\n    transform: translate(100px, 100px) rotate(0);\n  }\n\n  to {\n    transform: translate(100px, 100px) rotate(720deg);\n  }\n}\n\n@keyframes pencilStroke {\n  from {\n    stroke-dashoffset: 439.82;\n    transform: translate(100px, 100px) rotate(-113deg);\n  }\n\n  50% {\n    stroke-dashoffset: 164.93;\n    transform: translate(100px, 100px) rotate(-113deg);\n  }\n\n  75%,\n  to {\n    stroke-dashoffset: 439.82;\n    transform: translate(100px, 100px) rotate(112deg);\n  }\n}\n\n/* Learmo Loader */\n\n.pl,\n.pl__worm {\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n}\n\n.pl {\n  animation-name: bump9;\n  animation-timing-function: linear;\n  width: 1.5em;\n  height: 1.5em;\n}\n\n.pl__ring {\n  stroke: hsla(var(--hue), 10%, 10%, 0.1);\n  transition: stroke 0.3s;\n}\n\n.pl__worm {\n  animation-name: worm9;\n  animation-timing-function: cubic-bezier(0.42, 0.17, 0.75, 0.83);\n}\n\n/* Animations */\n@keyframes bump9 {\n  from,\n  42%,\n  46%,\n  51%,\n  55%,\n  59%,\n  63%,\n  67%,\n  71%,\n  74%,\n  78%,\n  81%,\n  85%,\n  88%,\n  92%,\n  to {\n    transform: translate(0, 0);\n  }\n\n  44% {\n    transform: translate(1.33%, 6.75%);\n  }\n\n  53% {\n    transform: translate(-16.67%, -0.54%);\n  }\n\n  61% {\n    transform: translate(3.66%, -2.46%);\n  }\n\n  69% {\n    transform: translate(-0.59%, 15.27%);\n  }\n\n  76% {\n    transform: translate(-1.92%, -4.68%);\n  }\n\n  83% {\n    transform: translate(9.38%, 0.96%);\n  }\n\n  90% {\n    transform: translate(-4.55%, 1.98%);\n  }\n}\n\n@keyframes worm9 {\n  from {\n    stroke-dashoffset: 10;\n  }\n\n  25% {\n    stroke-dashoffset: 295;\n  }\n\n  to {\n    stroke-dashoffset: 1165;\n  }\n}\n\n/* Wrapper */\n.ai-loader-wrapper {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  z-index: 1090;\n  animation: float 3s ease-in-out infinite;\n}\n\n/* Bubble */\n.ai-bubble {\n  position: absolute;\n  max-width: 240px;\n  padding: 10px 16px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.75);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  box-shadow:\n    0 8px 30px rgba(0, 0, 0, 0.12),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.4);\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  text-align: center;\n  pointer-events: none;\n  transform-origin: center;\n}\n\n.ai-bubble.inside {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n/* Positioning */\n.ai-bubble.bottom {\n  top: 100%;\n  margin-top: 5px;\n}\n\n.ai-bubble.top {\n  bottom: 100%;\n  margin-bottom: 14px;\n}\n\n/* Text */\n.ai-bubble-text {\n  display: inline-block;\n  line-height: 1.4;\n}\n\n/* Connector (modern instead of arrow) */\n.ai-bubble-connector {\n  position: absolute;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background: rgba(255, 255, 255, 0.85);\n  border-radius: 50%;\n  transform: translateX(-50%);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.ai-bubble.bottom .ai-bubble-connector {\n  top: -4px;\n}\n\n.ai-bubble.top .ai-bubble-connector {\n  bottom: -4px;\n}\n\n/* Animations */\n.fade-in {\n  animation: bubbleIn 0.35s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n}\n\n.fade-out {\n  animation: bubbleOut 0.25s ease-in forwards;\n}\n\n@keyframes bubbleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes bubbleOut {\n  from {\n    opacity: 1;\n    transform: scale(1);\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
